"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CsvFormatterStream = void 0;
const stream_1 = require("stream");
const formatter_1 = require("./formatter");
class CsvFormatterStream extends stream_1.Transform {
  constructor(formatterOptions) {
    super({
      writableObjectMode: formatterOptions.objectMode
    });
    this.hasWrittenBOM = false;
    this.formatterOptions = formatterOptions;
    this.rowFormatter = new formatter_1.RowFormatter(formatterOptions);
    // if writeBOM is false then set to true
    // if writeBOM is true then set to false by default so it is written out
    this.hasWrittenBOM = !formatterOptions.writeBOM;
  }
  transform(transformFunction) {
    this.rowFormatter.rowTransform = transformFunction;
    return this;
  }
  _transform(row, encoding, cb) {
    let cbCalled = false;
    try {
      if (!this.hasWrittenBOM) {
        this.push(this.formatterOptions.BOM);
        this.hasWrittenBOM = true;
      }
      this.rowFormatter.format(row, (err, rows) => {
        if (err) {
          cbCalled = true;
          return cb(err);
        }
        if (rows) {
          rows.forEach(r => {
            this.push(Buffer.from(r, 'utf8'));
          });
        }
        cbCalled = true;
        return cb();
      });
    } catch (e) {
      if (cbCalled) {
        throw e;
      }
      cb(e);
    }
  }
  _flush(cb) {
    this.rowFormatter.finish((err, rows) => {
      if (err) {
        return cb(err);
      }
      if (rows) {
        rows.forEach(r => {
          this.push(Buffer.from(r, 'utf8'));
        });
      }
      return cb();
    });
  }
}
exports.CsvFormatterStream = CsvFormatterStream;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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